import React, { useEffect, useState } from 'react';
import MapContainer from '../components/map/MapContainer';
import { httpGetSpotsByLocation } from "../hooks/spot/api";
import { httpGetStations } from "../hooks/stations/api";
import { useParams } from 'react-router-dom';

export default function Map() {
 
  const [spots, setSpots] = useState([]);
  const [buoys, setBuoys] = useState([]);
  const { loadbuoys } = useParams(); 
  

  useEffect(() => {

      // load spots
      httpGetSpotsByLocation().then(
        (result) => { setSpots(result)}
      )

      if (loadbuoys === "true") {

        // load buoys data
        httpGetStations().then(
          (result) => { 
            setBuoys(result)
          }
        )

        //setBuoys(buoysCoordinates);
      }
    }, [loadbuoys])
  
    const landingPage = () => {
          return <MapContainer array={spots} buoys={buoys} />
    }

    return (
      <div>
        { landingPage() } 
      </div>
    )
}
